import React, { useEffect } from "react";
import { IMAGES } from "../../static/assets/images";
import { TEXTS } from "../../static/texts";
import sectionStyles from "../sectionStyles.module.css";
import styles from "./style.module.css";

const products = [
  {
    title: "Cubus 0.22 prototipo",
    description: "Capacidad 220 lts",
    imgSrc: IMAGES.CUBUS_022,
  },
  {
    title: "Cubus 0.6",
    description: "Capacidad 600 lts",
    imgSrc: IMAGES.CUBUS_06,
  },
  {
    title: "Cubus 1.0",
    description: "Capacidad 1.000 lts",
    imgSrc: IMAGES.CUBUS_10,
  },
  {
    title: "Cubus 1.5",
    description: "Capacidad 1.500 lts",
    imgSrc: IMAGES.CUBUS_15,
  },
  {
    title: "Cubus 3.0",
    description: "Capacidad 3.000 lts",
    imgSrc: IMAGES.CUBUS_30,
  },
  {
    title: "Cubus 5.0",
    description: "Capacidad 5.000 lts",
    imgSrc: IMAGES.CUBUS_50,
  },
  {
    title: "Cubus 10.0",
    description: "Capacidad 10.000 lts",
    imgSrc: IMAGES.CUBUS_100,
  },
  {
    title: "Lagar 3.5",
    description: "Capacidad 3.500 lts",
    imgSrc: IMAGES.LAGAR_35,
  },
];

export const Cubas = ({ pageTop }) => {
  useEffect(() => {
    pageTop.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [pageTop]);

  return (
    <>
      <div className={styles.bannerContainer}>
        <h1 className={sectionStyles.titleText}>
          {TEXTS.SERVICES_CUBAS_TITLE}
        </h1>
      </div>
      <div className={sectionStyles.redContainer}>
        <p className={sectionStyles.flavorText}>
          {TEXTS.SERVICES_CUBAS_FLAVOR}
        </p>
      </div>
      <div className={sectionStyles.blackContainer}>
        <h3 className={sectionStyles.headerText}>
          {TEXTS.SERVICES_CUBAS_MODELS_HEADER}
        </h3>
        <div className={styles.productsWrapper}>
          {products.map((prod, index) => (
            <>
              <div key={`CUBA_${index}`} className={styles.productCard}>
                <img
                  src={prod.imgSrc}
                  alt={prod.title}
                  className={styles.productImage}
                />
                <h4 className={styles.cardTitle}>{prod.title}</h4>
                <p className={styles.cardContent}>{prod.description}</p>
              </div>
              {index < prod.length - 1 && (
                <div className={styles.productSeparator} />
              )}
            </>
          ))}
        </div>
      </div>
    </>
  );
};
